<template>

      <div class="container">

            <div class="title4">

      <row>

      <template v-if="userAccountData.valid_state_license==='YES'">

      <router-link :to="{ path: '/shop/'}">
        <img :src='"@/assets/images/UNIBUD-WHITE-TRANSPARENT.svg"' class="unibud-black" alt="logo" />
      </router-link>
      </template>
      <template v-else>
        <img :src='"@/assets/images/UNIBUD-WHITE-TRANSPARENT.svg"' class="unibud-black" alt="logo" />
      </template>

      <br />
      <br />
      <br />

    </row>

    <row>
      <h3>Account Information</h3>
    </row>


              <row>

    <table class="table table-striped table-bordered table-hover table-condensed">
      <thead>
      <tr>

        <td>Name</td>
       <td>
         {{userAccountData.firstname}} {{userAccountData.lastname}}
        </td>
      </tr><tr>


        <td>Email</td>
        <td><input
            type="text"
            id="email"
            class="form-control"
            :value="userAccountData.email"
            @input="userAccountData.email = $event.target.value"
        >
        </td>
      </tr><tr>

        <td>Phone Number</td>
        <td><input
            type="text"
            id="phone"
            class="form-control"
            :value="userAccountData.phone"
            @input="userAccountData.phone = $event.target.value"
        >
        </td>
      </tr><tr>

      <td>Valid State License</td>
      <td v-if="userAccountData.valid_state_license='YES'">
        YES
      </td>
      <td v-else>
        NO
      </td>
      </tr><tr>




      </tr>
      </thead>
    </table>


    <button @click="update_account_data()"  class="btn-solid btn">Save Changes</button>

              </row>


            </div>

        <div class="col-sm-12">
          <div class="text-center mt-3">
            <a :href="app_link_local" :class="'btn btn-solid'"> back to app</a>
          </div>
        </div>

      </div>







</template>

<script>

// import * as api from '@/api'
import {mapGetters, mapState} from "vuex";

export default {
  computed: {
    ...mapState({
      app_link: state=>state.cart.app_link
    }),
    ...mapGetters({
      userAccountData: 'auth/getUserAccountData',
    })
  },
  data() {
    return {
      app_link_local: "highland://?confirmation=1312",

    };
  },
  methods:{
    update_account_data() {
      this.$store.dispatch('cart/updateAccountData', {email:this.userAccountData.email , phone:this.userAccountData.phone })
    }
  },
  async mounted() {

  }
};
</script>
